export default {
  lang: '繁',
  test: '测试',
  AddToCart: '加入購物車',
  changeLangSuccess: '語言切換成功！',
  changeCurSuccess: '貨幣切換成功！',
  Input: {
    email: '請輸入正確的郵箱',
    number: '請輸入數字',
    input: '請輸入',
    text: '',
    date: '請選擇日期',
    password: '兩次輸入密碼不一致',
    textarea: '',
    emailNotFound: '郵箱不存在',
    logopassword: '請輸入密碼',
    confirmpassword: '兩次輸入密碼不一致',
    nomessage: '暫無數據',
    phoneincorrect: '電話號碼格式不正確',
    faxincorrect: '傳真號碼格式不正確',
    PAGENOTFOUND: '抱歉，您所訪問的頁面不存在～',
    selectPayment: '請選擇付款方式',
    searchTips:'請輸入搜索內容',
    Home:'首頁',
    All:'全部',
    PreviousDay:'上一日',
    NextDay:'下一日'
  },
  Message: {
    Logout: '您尚未登陸或已登入超時，請重新登入',
    Message: '消息',
    Confirm: '確認',
    Cancel: '關閉',
    msg401: '權限不足！',
    msg400: '系統異常！',
    msg404: '請求接口不存在！',
    msg500: '服務器錯誤！',
    msg502: '网络错误！',
    msg503: '服務不可用，服務器暫時過載或維護。',
    SucceedInOperating: '操作成功',
    SavedSuccessfully: '保存成功',
    Loading: '頁面正在加載，請稍候',
    ViewDetail: '瞭解更多',
    FollowUs: '關注我們',
    Evidence: '憑據',
    UploadEvidence: '上傳憑據',
    OrderNumber: '訂單編號',
    Remark: '備註',
    Image: '圖片',
    SubmitSuccess: '提交成功',
    SubmitFailed: '提交失敗',
    DeliveryDate: '送貨日期',
    DeliveryTime: '送貨時段',
    DeliveryInstructions: '送貨指示',
    DeliveryMark: '預訂請預早⼀天，每天晚上10 點截單，套餐滿800 包市區送貨。10點前⼊數⽅可隔天送貨。',
    All: '全部',
    PlsAddPiUpAddr: '請添加相關自提地址信息！',
    NoneAddPiUpAddr: '查詢不到相關自提地址信息！',
    AdditionalDiscount: '額外折扣已生效',
    Delete: '刪除',
    SuccessfullyDeleted: '刪除成功',
    Save: '保存',
    SaveAll: '保存所有',
    noRMBStripe: '貨幣RMB不支持Stripe支付，請選擇其他支付方式或切換貨幣模式',
    textareaError: '請輸入5個字符以上',
    FindNoProduct: '系統正忙，請重新刷新頁面',
    HomeTips: '首頁',
    News: '最新消息',
    LearnMore: '瞭解更多',
    TipsA: '點擊產品查看詳細訊息和放大產品圖片',
    TipsB: '符合您搜索要求的',
    TipsC: '個產品',
    LoginNow: '立即登入',
    TipsD: '查看12個以上產品',
    TipsE: '搜索結果 1-10 共有',
    NoMore: '没有更多了',
    Next: '下一個',
    Prev: '上一個',
    Catalog: '目錄',
    AskFor: '欲查詢報價，請按',
    ProductInformation: '產品資料',
    OtherDetails: '其他資料',
    Fav: '收藏',
    Payments: '付款方式',
    ProductList: '產品目錄',
    RecommendedProducts: '推薦產品',
    ResetOptions: '重置選項',
    Personal: '個人',
    Enterprise: '企業',
    Found:'找到',
    Products:'產品',
    Share:'分享',
    Customizedwineset:'定制酒套',
    ViewProduct: '查看產品',
    NoContent: '暫無',
    Items: '件物品'
  },
  Account: {
    MemberCenter: '會員中心',
    MemberInformation: '用戶信息',
    MyMessages: '我的信箱',
    MyFavorite: '我的最愛',
    MyOrder: '我的訂單',
    DeliveryAddress: '送貨地址',
    Logout: '登出',
    Welcome: '歡迎!',
    SISA: '選擇成功',
    MyUpload: '我的上傳',
    LatestNews: '最新消息',
    ChangePwd: '更改密碼'
  },
  RegNPay: {
    BackText: '返回修改',
    UploadButtonText: '上傳文件(jpg, png, pdf)',
    UploadingText: '正在上傳',
    ConfirmText: '確認送出',
    UploadSuccessfulText: '上傳成功',
    UploadFailText: '上傳失敗',
    NoFileText: '沒有選中文件',
    UploadLengthText: '最多只能上載{0}檔案',
    UploadSizeText: '最多只能上傳{0}M',
    PleaseSelect: '請選擇',
    SubRecord: '提交紀錄',
    ReferenceNum: '參考編號',
    SubmissionDate: '提交日期',
    Print: '列印',
    PlsPayWay: '請選擇付款方式',
    PreviewTitleText: '請再次確認頁面',
    FormatErrorText: '請輸入正確電郵地址',
    RequiredText: '請檢查你的答案'
  },
  product: {
    Attribute: '產品屬性',
    PriceScreening: '價格篩選',
    ProductCode: '產品代碼',
    Dimension: '尺寸',
    SingleUnit: '單位',
    buy: '立即購買',
    addToCart: '加入購物車',
    buyNow: '立即購買',
    favorite: '加入我的清單',
    priceTitle: '價格',
    countTitle: '數量',
    youWouldLike: '猜你喜歡',
    moreTips: '點擊加載更多',
    none: '沒有了',
    noneInCat: '當前目錄無產品，請選擇其他目錄',
    notifyMe: '到貨通知',
    purchasing: '采購中',
    comments: { title: '商品評論' },
    detail: '產品詳情',
    overView: '產品簡介',
    specification: '使用説明',
    attr: { 0: '尺寸', 1: '顔色' },
    SaleOut: '售罄',
    offSale: '已下架',
    Recommend: '會員推薦',
    Remarks: '備注',
    EnterRemaks: '請填寫備注',
    up: '上一個',
    down: '下一個',
    logouted: '您已退出登錄！',
    loginow: '現在重新登入？',
    successInAdding: '添加成功',
    successInRemoving: '取消成功',
    ProductIntro: '產品介紹',
    ProductIntroduction: '產品介紹',
    UserReviews: '用戶評論',
    OwnerReply: '商家回復',
    per: '第',
    page: '頁',
    Screening: '篩選',
    Resetall: '重置所有篩選條件',
    PriceHL: '價格從高至低',
    PriceLH: '價格從低至高',
    Producttitle: '產品列表',
    Paixu: '排序',
    Total: '共',
    Product: '個產品',
    ProductDetail: '產品詳情',
    Unit: '單位',
    Filter: '篩選',
    ViewAll: '查看更多',
    SortBy: '排序',
    Createdate:'創建時間',
    ProductCate: '產品類別'
  },
  Shoppingcart: {
    ShoppingcartTitle: '購物車',
    Merchant: '商家',
    Product: '產品',
    Quantity: '數量',
    Price: '價格',
    Total: '商品總價',
    CheckoutList: '確認訂單',
    Checkout: '安全結算',
    goTOCart: '前往購物車',
    vat: '包含增值稅',
    None: '購物車裏空空如也，現在去購買？',
    more: '更多',
    hide: '收起'
  },
  Login: {
    doLogin: '登入',
    LoginTitle: '會員登入',
    NewUser: '新用戶',
    RegNow: '現在注冊',
    ForgetPwd: '忘記密碼',
    RememberMe: '記住我',
    FaceBookUse: '使用facebook賬戶登錄',
    UserName: '登錄用戶名/郵箱地址',
    EnterEmail: '請輸入郵箱地址',
    CorrectEmail: '請輸入正確郵箱地址',
    LoginPwd: '請輸入密碼',
    LoginoldPwd: '密碼不正確',
    Loginerror: '賬號或密碼不正確',
    LoginSucceeded: '登入成功！',
    Account: '個人中心'
  },
  Register: {
    RegisterTitle: '註冊會員',
    UserEmail: '郵箱',
    or: '或',
    UserRegPassword: '密碼',
    UserNewPassword: '新密碼',
    UserOldPassword: '舊密碼',
    UserRegTips: '最少6個由字母或數字組成的字符',
    UserConfirmPassword: '確認密碼',
    UserFirstName: '名字',
    UserLastName: '姓氏',
    UserSurname: '姓氏',
    UserContactNumber: '聯繫電話',
    UserBirthDate: '出生日期',
    UserGender: '性別',
    UserMale: '男',
    UserFemale: '女',
    UserLanguage: '語言',
    UserLanguageE: '英文',
    UserLanguageT: '繁體',
    UserLanguageS: '簡體',
    RegisterBtn: '註冊',
    RegisterAgree: '我同意使用條款',
    RegisterEmail: '郵箱不能為空',
    RegisterEmail01: '請輸入正式的郵箱格式',
    RegisterPassword: '請輸入密碼',
    RegisterNewPassword: '請再次輸入密碼',
    RegisterNewPassword01: '兩次輸入密碼不一致',
    RegisterFirstName: '請輸入您的姓名',
    RegisterLastName: '請輸入您的名稱',
    RegisterAgree_check: '請勾選',
    RegisterMobile: '請輸入您的手提電話',
    RegisterSuccess: '註冊成功',
    RegisterFail: '註冊失敗',
    RegisterWelcome: '恭喜您,註冊成功',
    RegisterTips: '此電子郵箱尚未註冊，請立即註冊成為會員！',
    Login: '跳轉登錄',
    Registerdigital: '長度由8至20個字符 須包含大寫字母、小寫字母及數字'
  },
  DeliveryAddress: {
    AddAddress: '新增地址',
    ChooseDeliveryAddress: '選擇送貨地址',
    EditBtn: '编辑',
    DeleteBtn: '删除',
    AddDeliveryAddress: '添加新的收貨地址',
    PostalCode: '郵政編碼',
    Area: '地區',
    Province: '省份',
    District: '區份',
    Address: '地址',
    DefaultAddress: '設為默認送貨地址?',
    SaveBtn: '保存',
    ResetBtn: '重置',
    CloseBtn: '關閉',
    YesBtn: '是',
    NoBtn: '否',
    AddFirstName: '名字',
    AddLastName: '姓氏',
    UserContactNumber: '聯繫電話',
    Mobile: '手提電話',
    Addressprovince: '請選擇省份',
    AddressArea: '請選擇地區',
    Detail: '街道/屋苑/樓層/室'
  },
  MyCoupon: {
    MyCoupon: '我的優惠券',
    Coupon: '優惠券',
    PeriodOfValidity: '有效期',
    NoCoupon: '暫無優惠券',
    CouponStatus: '優惠券狀態',
    SelectCouponStatus: '請選擇優惠券狀態',
    TotalNum: '共有',
    Piece: '張',
    NotUse: '可用',
    DoNotUse: '不可用',
    Used: '已用',
    Among: '其中',
    All: '全部'
  },
  MyFavorite: {
    MyFavorite: '我的最愛',
    LearnMore: '瞭解更多',
    RemoveProduct: '移除產品',
    RemoveSuccess: '移除成功',
    AddSuccess: '加入成功'
  },
  Notification: {
    MyMessages: '我的信箱',
    MsgList: '消息列表',
    TotalRecQtyWithSymbol: '總記錄數 ：',
    UnreadWithSymbol: '未讀記錄數 ：',
    MsgUnreadOnly: '只看未讀消息',
    MsgMarkAsRead: '標記為已讀',
    CheckAllOrNot: '全選/反選',
    MsgSender: '發信人',
    MsgSubject: '主題',
    MsgSenderDate: '發信時間',
    MsgReadStatus: '狀態',
    Details: '瞭解詳情',
    More: '更多',
    Back: '返回',
    MsgContent: '内容',
    Send: '發送',
    Unread: '未讀',
    Read: '已讀',
    UpdateSucceeded: '更新成功!',
    Check: '選擇',
    Id: '序號'
  },
  Forgetpassword: {
    ForgetPassword: '忘記密碼',
    ResetPwdTips: '請輸入您用於註冊的電子郵件，然後點擊“下一步”繼續',
    LoginNameEmail: '郵箱',
    NextStep: '下一步',
    ResetPwdSuccess: '重置密碼已發送到您的郵箱，請查看。',
    NotEmail: '收不到重設密碼電郵',
    ToReEnter: '按此重新填寫',
    EnterEmail: '請輸入郵箱地址',
    CorrectEmail: '請輸入正確的郵箱地址',
    ResetPwd: '重設密碼'
  },
  MemberInfo: {
    MemberInfoTitle: '用戶信息',
    UserAccount: '用戶賬號',
    ModifyPassword: '修改密碼',
    EnterUserName: '請輸入名字',
    EnterUserLastName: '請輸入姓氏',
    EnterUserGender: '請選擇你的性別',
    EnterUserPhone: '請輸入聯係電話',
    EnterFax: '請輸入傳真號碼',
    EnterUserBrithDate: '請選擇出生日期',
    EnterOldPwd: '請輸入舊密碼',
    EnterNewPwd: '請輸入新密碼',
    EnterComfirmPwd: '請輸入確認密碼',
    EnterNumber: '請輸入數字',
    PwdNotCorrect: '兩次密碼不一致',
    AgreeEmail: '本人同意天才兒童書店透過電郵地址向我發送推廣資訊',
    DDMM: '日/月'
  },
  Order: {
    OrderTitle: '我的訂單',
    OrderDetail: '訂單詳情',
    OrderPay: '立即支付',
    OrderCancel: '訂單取消',
    OrderComplete: '訂單完成',
    OrderClose: '訂單關閉',
    CartSubtotal: '小計',
    DeliveryCharge: '運輸費用',
    TotalPrice: '總價',
    OrderStatus: '訂單狀態',
    OrderDateTime: '訂單日期及時間 ',
    OrderNumber: '訂單編號',
    OrderSearch: '訂單搜索',
    EnterProductName: '請輸入產品名稱',
    Items: '項',
    OrderComment: '評價',
    PromotionCode: '促銷碼',
    RecommendationCode: '會員推薦碼',
    CommodityPrice: '商品總價',
    Full: '買滿',
    Minus: '減',
    Hit: '減',
    Precent: '%',
    Discount: '優惠價格',
    Cancel: '取消',
    Paid: '已付款',
    Unpaid: '未付款'
  },
  Concessions: {
    Cannot: '優惠券与优惠码不可不可同时使用'
  },
  Payment: {
    ReturnHomePage: '返回首頁',
    PayStatus: '支付狀態',
    PayFailTips: '本次支付失敗，請檢查您的支付戶口后重新嘗試。',
    PaysuccessTips: '本次支付成功'
  },
  CheckOut: {
    Ordersummary: '訂單摘要',
    Input: '請輸入',
    expiryDate: '過期日期',
    awsl: 'awsl',
    expressError: '快遞異常！請選擇其他快遞。',
    confirmAddress: '請先確認送貨地址',
    pay: '支付',
    CheckOutTitle: '確認訂單',
    Merchant: '商家',
    Product: '產品',
    Qty: '數量',
    Price: '價錢',
    SplitDelivery: '拆單',
    ShippingMethod: '送貨方式',
    PleaseSelect: '請選擇',
    Selected: '已選擇',
    Name: '名字',
    Phone: '電話',
    Address: '地址',
    Pickup: '自取',
    Change: '新增或更改地址',
    DeliveryCharge: '運輸費用',
    SubTotal: '商品小計',
    PayBy: '支付方式',
    Couponcode: '優惠碼',
    confirm: '確認',
    Total: '共',
    BacktoShoppingCart: '返回購物車',
    Last: '上一頁',
    Previous: '上一頁',
    Checkout: '確認訂單',
    Next: '下一頁',
    Delivery: '配送方式與運費',
    SelectDeliveryAddress: '選擇送貨地址',
    LastName: '姓氏',
    Edit: '更改地址',
    Delete: '刪除地址',
    Select: '選取',
    NewAddress: '添加新的收貨地址',
    PickUp: '自取',
    FirstName: '名字',
    ZipCode: '郵政編碼',
    Mobile: '手機',
    Country: '地區',
    Province: '地區/省份',
    City: '區份',
    Close: '關閉',
    PickupDate: '自取日期',
    PickupTime: '自取時間',
    Morning: '早上',
    Afternoon: '下午',
    PickAddressError: '自提信息必須完整',
    AddressLock: '地址已被選中不可刪除',
    CompanyName: '門店',
    CompanyPhone: '門店電話',
    CompanyAddress: '門店地址',
    PickupAddress: '自取地址',
    Save: '保存',
    PleaseChoose: '請選擇',
    PleaseSelectdate: '請選擇日期',
    PleaseSelecttime: '請選擇時間',
    ConfirmationOfOrder: '確認訂單',
    Concessions: '優惠信息',
    PaymentMethod: '支付方式',
    Complete: '完成',
    OrderPreview: '訂單預覽',
    CandP: '優惠券與促銷碼不能同時使用',
    promotionCodeError: '請輸入正確的促銷碼',
    promotionCodetips1: '請先刪除現有的促銷碼',
    Use: '使用',
    As: '作爲',
    PaymentMethodError: '支付方式尚未选择！',
    OrderSent: '訂單已發出',
    PaymentProcess: '請繼續完成付款程序',

    CountryName: '國家名稱',
    ProvinceName: '省份名稱',
    CityName: '城市名稱',
    SFPointType: '自提點類型'
  },
  Address: {
    Country: '請選擇國家',
    Province: '請選擇省份',
    Address: '請填寫詳細地址'
  },
  MemberPoints: {
    MemberPoints: '會員積分',
    PointsDetail: '積分明細',
    PointsIncome: '積分收入',
    PointsSpending: '積分支出',
    OrderTime: '訂單時間',
    OrderNo: '訂單編號',
    Income: '收入',
    Spending: '支出',
    IncomeSpending: '收入/支出',
    DetailedDescription: '詳細説明',
    TotalPoints: '總積分',
    Hello: '您好',
    Equals: '等於',
    Integral: '積分',
    PointsTips: '積分使用常見問題',
    PointsType: '積分類別',
    Points: '積分',
    PointsMode: 'PointsMode'
  },
  Cms: {
    AboutUS: '關於我們',
    OurStores: '門市',
    BusinessHours: '營業時間',
    BigSales: '熱銷產品',
    WhatNews: '今期流行',
    PlsChoose: '請點擊選擇您想要查看的內容：'
  },
  promotion: {
    enter: '點擊進入',
    main: '天才兒童最佳之選',
    monterssori: {
      title1: '蒙特梭利教學法',
      title2: '培養幼兒自覺主動的學習和探索精神',
      banner1: '做自己的老師',
      banner2: '讓兒童自發性地主動學習',
      banner3: '自己構建完善的人格'
    }
  },
  home: {
    LatestProducts:'最新產品',
    News: '新聞中心',
    More: '更多',
    Category: '產品目錄',
    Weaccept: '我們接受',
    Order: '訂購',
    TelSearch: '電話查詢',
    AllProduct: '全部產品',
    ResetProduct: '重置',
    Address: '地址',
    ViewDetail: '查看詳情',
    Screening: '篩選',
    Resetall: '重置所有篩選條件',
    PriceHL: '價格從高至低',
    PriceLH: '價格從低至高',
    Thatsall: '以上是全部內容',
    Search: '搜索結果',
    ReadMore: '更多',
    Activity: '活動',
    ViewMore:'查看更多',
    AboutUs: '關於我們',
    ProductCatalog: '產品目錄',
    OnlineSales: '線上銷售'
  },
  Action: {
    ReturnHomePage: '返回首頁',
    OrderDetails: '訂單詳情',
    PaymentSuccessTips: '支付成功',
    PaymentFailTips: '支付失敗',
    Checkout: '確認訂單',
    Save: '保存',
    Confirm: '確認',
    PromotionCodeTips: '請輸入優惠碼',
    Share: '分享',
    LoadMore: '加載更多',
    FacebookLogin: 'Facebook 登入',
    HotPot: '火鍋類',
    BBQ: '燒烤類',
    Dishes: '餸菜類',
    Package: '套餐',
    ProductSearch: '產品搜尋',
    Total: '共',
    Products: '個產品',
    SearchPiUpAddr: '搜索自提點地址'
  },
  accountHeader: {
    MemberFile: '會員檔案',
    Favorite: '喜愛項目',
    GrantsCredits: '積分獎勵',
    MyOrder: '我的訂單',
    ECoupon: '電子禮券',
    MembershipDiscount: '會員優惠'
  },
  regnpay: {
    successful: '感謝您的提交',
    reply: '我們會儘快回復您',
    ContactUs: '聯絡我們'
  },
  messageTips: {
    NoContent: '暫無內容',
    NoComments: '暫無評論',
    NoProduct: '對不起，沒有你搜索的產品'
  },
  photo: {
    photo: '相片集',
    BackText: '返回上一級'
  },
  Calendar: {
    KnowMore: '了解更多',
    Time: '時間',
    Venue: '地點',
    NoEvent: '今日暫無活動'
  },
  Enquiry: {
    DocumentInbox: '收件夾',
    DocumentOutbox: '寄件夾',
    Enquiry: '詢價單',
    ShipMarkImage: '船嘜圖樣',
    ShipMark: '船嘜',
    EnquiryTitle: '報價查詢',
    Quota: '報價單',
    BuyOrder: '訂貨單',
    InviceInfo: '發票',
    Delivery: '發貨單',
    Packing: '裝箱單',
    Case: '個案',
    Subject: '主旨',
    Date: '日期',
    TotalRecords: '总共',
    List: '目錄',
    Search: '搜尋',
    CaseStatus: '個案狀態',
    SearchType: '查詢類型',
    CaseType: '編號類型',
    Document: '文件',
    MyAccount: '我的賬戶',
    AddToEnquiry: '加入報價查詢',
    YourRef: '客戶參考編號',
    ShippingInformation: '送貨資料',
    NegotiationBox: '協商記錄處',
    leavemessage: '請於以下留言:',
    DraftEnquiry: '報價查詢初稿',
    Delete: '刪除',
    AddProduct: '添加產品',
    Image: '產品圖像',
    ProductInformation: '產品資料',
    ProductPackInformation: '產品包裝資訊',
    Quantity: '數量',
    ProductCode: '產品編號',
    ProductName: '產品名稱',
    OtherRequirement: '其他要求',
    DeliveryLeadTime: '送貨排程',
    DeliverMethod: '送貨方式',
    ShipmentTerms: '貨運條件',
    PaymentTerms: '付款方式',
    Remarks: '備註',
    Tips: '（如果您想保存此查詢並稍後發送，請按“保存草稿”按鈕。）',
    SaveDraft: '儲存作初稿',
    PreviewBeforeSending: '預覽',
    ConfirmandSend: '確認送出',
    Back: '返回',
    Clear: '清除',
    FirstName: '名字',
    LastName: '姓氏',
    Title: '職位',
    Company: '公司名稱',
    Address: '地址',
    City: '城市',
    State: '省份',
    PostalCode: '郵政編碼',
    Country: '國家',
    Phone: '電話',
    Mobile: '流動電話',
    Telephone: '電話',
    Fax: '傳真',
    Email: '電郵',
    From: '寄件者',
    PrintFormat: '列印格式',
    Status: '狀態',
    CurrentEnquiry: '最近報價查詢',
    CaseNo: '個案編號',
    QuotationNo: '報價單編號',
    MessageHistory: '協商記錄',
    Send: '送出',
    UnitPrice: '單價',
    SubTotal: '合共',
    Total: '總共',
    ProInvcode: '訂貨單編號',
    OrderStatusBox: '訂單狀況記錄處',
    OrderStatusHistory: '訂單狀況記錄',
    ProformaInvoice: '訂貨單',
    QuotationList: '報價單',
    MessageContent: '請輸入留言內容',
    EnquiryNo: '報價查詢編號',
    SelectedProduct: '已選擇產品',
    Savedsuccessfully: '保存成功',
    Submittedsuccessfully: '提交成功',
    QuotationInquiry: '多謝您的報價查詢. 我們會儘快回覆您.',
    ClickHere: '按這裡到 << 報價查詢目錄 >>',
    SuccessfullyDeleted: '删除成功',
    Invoice: '發票',
    InvoiceNo: '發票編號',
    TOTALAMOUNTOFTHISINVOICE: '此发票总额为',
    PackingListNo: '裝箱單目錄編號',
    NetWeight: '净重 (公斤)',
    GrossWeight: '毛重 (公斤)',
    TotalNetWeight: '总共净重 (公斤)',
    TotalGrossWeight: '总共毛重 (公斤)',
    DeliveryDate: '送貨日期',
    TotalVolume: '总共容量 (CBM)',
    TotalCarton: '总共箱数',
    CountryofOrigin: '产地来源',
    ShippingMark: '船唛',
    ShippingMarkImage: '船嘜圖樣',
    ShipmentSchedule: '裝運安排表',
    NoShipmentSchedule: '暫無裝運安排',
    ShipmentScheduleNo: '裝運安排表編號',
    OrderQty: '訂貨數量',
    ShipmentQty: '裝運數量',
    ExpectedShipmentDate: '預計裝運日期',
    ShippedDate: '裝運日期',
    Balance: '數量餘額',
    Norecord: '沒有任何紀錄 !',
    Pleaseselect: '請選擇要刪除的產品',
    MinOrderQty: '最少訂貨量',
    Code: '編號',
    Type: '類型',
    AuthorizedSignature: '授權簽名',
    OtherInformation: '其他資料',
    Item: '項目',
    Print: '列印',
    Sign: '簽署',
    SignTips: '請簽署及蓋印已確認',
    Attn: '收件人',
    TransactionAmount: '交易金額',
    AdditionalCharges: '附加費用',
    Discount: '折扣',
    NotShipped: '賣家未發貨',
    PTXOrder: '詢價訂單',
    negotiateMinQty: '最低議價量',
    SellType: '銷售類型',
    RetailBargaining: '零售議價',
    Retail: '零售',
    Bargaining: '議價'
  },
  Hompage: {
    BookNow: '立即預約',
    GlassesTryOn: '眼鏡試戴',
    Tryitoutnow: '立即試擺',
    Minimum: '最小訂購數量',
    TryOnNow: '立即試戴',
    LatestEyewearProducts: '最新眼鏡產品',
    StaffRecommendation: '店員推薦款',
    Brand: '品牌',
    ContactUs: '聯絡我們',
    Home: '首頁',
    Share: '分享',
    Collect: '收藏',
    Modeltry: '默認場景試擺',
    UploadLocalPhotos: '上傳本地照片',
    DownloadPhotos: '下載圖片',
    Close: '關閉',
    Left: '左移',
    Right: '右移',
    Up: '上移',
    Down: '下移',
    GlassesZoom: '眼鏡縮放',
    ReadMore: '閱讀全文',
    ConsultNow: '立即咨詢',
    OurServices: '我們的服務',
    OurAlliance: '我們的聯盟',
    HotRecommendations: '熱門推介',
    CustomerExperience: '客戶體驗',
    Cancel: '取消',
    ContinueShopping: '繼續購物',
    orderTips: '訂單金額需購滿HK$ 500',
    MyFav: '我的喜爱',
    Cart: '購物車',
    LoginTips: '登入 | 註冊',
  }
};
